export default __webpack_public_path__ + "img/bjXMhKJN.ebac38ef.svg";